export default __webpack_public_path__ + "static/media/whatsapp-banner old.321b314d.jpg";